import React from 'react';
import {Search} from '@carbon/icons-react';

type Props = {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    onClearAll: () => void;
    isMaxReached: boolean;
    selectedCount: number;
};

export default function SpecialtyFilterControls({
    searchTerm,
    onSearchChange,
    onClearAll,
    isMaxReached,
    selectedCount,
}: Props) {
    return (
        <div className="specialty-filter-controls">
            <div className="search-bar">
                <Search size={16} className="search-icon" />
                <input
                    type="text"
                    placeholder={isMaxReached ? 'Maximum Specialties Selected' : 'Search specialties...'}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="search-input"
                />
            </div>
            <button
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClearAll();
                }}
                className="clear-all-btn"
                disabled={selectedCount === 0}
                data-testid="clear-all-btn"
            >
                Clear All
            </button>
        </div>
    );
}
